var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { memoize } from '../../../../../utils/mobx/decorators/memoize';
import { traitRegistry } from '../../../../../registry/Registry';
import { head } from '../../../../../utils/helper/lodash_replacements';
export class AspectKeyProxies {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get globalOrLocal() {
        return this.parent;
    }
    get aspect() {
        return this.parent.aspect;
    }
    get atsOf() {
        return new Proxy(this, {
            get: (x, traitKey) => {
                return this.globalOrLocal.aspectKey(traitKey).keyAttached.attachedTraits;
            },
        });
    }
    get atOf() {
        return new Proxy(this, {
            get: (x, traitKey) => {
                return head(this.globalOrLocal.aspectKey(traitKey).keyAttached.attachedTraits);
            },
        });
    }
    get activesOf() {
        return new Proxy(this, {
            get: (x, traitKey) => {
                return this.globalOrLocal.aspectKey(traitKey).keyValue.activeAttachedTraits;
            },
        });
    }
    get activeOf() {
        return new Proxy(this, {
            get: (x, traitKey) => {
                return this.globalOrLocal.aspectKey(traitKey).keyValue.activeAttachedTraitSingle;
            },
        });
    }
    get valuesOf() {
        return new Proxy(this, {
            get: (x, traitKey) => {
                return this.globalOrLocal.aspectKey(traitKey).keyValue.valuesMultipleWithDefaultFallback;
            },
        });
    }
    get valueOf() {
        return new Proxy(this, {
            get: (x, traitKey) => {
                return this.globalOrLocal.aspectKey(traitKey).keyValue.valueSingleWithDefaultFallback;
            },
            set: (x, key, value) => {
                this.aspect.aspectSetValue.setValue({ key, value });
                return true;
            },
        });
    }
    get mixedValueOf() {
        return new Proxy(this, {
            get: (x, traitKey) => {
                return traitRegistry.registry_object[traitKey].multiple
                    ? this.globalOrLocal.aspectKey(traitKey).keyValue.valuesMultipleWithDefaultFallback
                    : this.globalOrLocal.aspectKey(traitKey).keyValue.valueSingleWithDefaultFallback;
            },
        });
    }
    get scaledValueOf() {
        return new Proxy(this.aspect, {
            get: (x, traitKey) => {
                return this.globalOrLocal.aspectKey(traitKey).keyValue.scaledValueSingleWithDefaultFallback;
            },
            set: (x, key, scaledValue) => {
                this.aspect.aspectSetValue.setValue({ key, scaledValue });
                return true;
            },
        });
    }
}
__decorate([
    memoize
], AspectKeyProxies.prototype, "atsOf", null);
__decorate([
    memoize
], AspectKeyProxies.prototype, "atOf", null);
__decorate([
    memoize
], AspectKeyProxies.prototype, "activesOf", null);
__decorate([
    memoize
], AspectKeyProxies.prototype, "activeOf", null);
__decorate([
    memoize
], AspectKeyProxies.prototype, "valuesOf", null);
__decorate([
    memoize
], AspectKeyProxies.prototype, "valueOf", null);
__decorate([
    memoize
], AspectKeyProxies.prototype, "mixedValueOf", null);
__decorate([
    memoize
], AspectKeyProxies.prototype, "scaledValueOf", null);
